import React, { forwardRef } from 'react';

import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import classNames from 'classnames';

import type { TableHeadersTranslation } from '../../../routes-planner/translations';

import './route-header.scss';

interface Props {
	allRowExpanded: boolean;
	onAllCollapseToggle: () => void;
	shouldShowVehicles: boolean;
	shouldShowTrailer: boolean;
	translation: TableHeadersTranslation;
}

const RouteHeader = forwardRef<HTMLDivElement, Props>(
	({ allRowExpanded, onAllCollapseToggle, translation, shouldShowVehicles, shouldShowTrailer }: Props, ref) => {
		return (
			<div className="route-header" ref={ref} data-test-id="route-header">
				<div className="header-cell expand-collapse-all" data-text-id="headerCell">
					<div onClick={onAllCollapseToggle} className="expand-collapse-icon">
						<BringgIcon
							iconName={BringgFontIcons.ChevronRight}
							className={classNames({ 'is-expanded': allRowExpanded })}
						/>
					</div>
				</div>
				<div className="header-cell route-column" data-text-id="headerCell">
					{translation.routeId}
				</div>
				<div className="header-cell driver-column" data-text-id="headerCell">
					{translation.driverName}
				</div>
				{shouldShowVehicles && (
					<div className="header-cell vehicle-column" data-text-id="headerCell">
						{translation.vehicleName}
					</div>
				)}
				{shouldShowTrailer && (
					<div className="header-cell trailer-column" data-text-id="headerCell">
						{translation.trailerName}
					</div>
				)}
				<div className="header-cell tasks-column" data-text-id="headerCell">
					{translation.tasksCount}
				</div>
				<div className="header-cell duration-column" data-text-id="headerCell">
					{translation.duration}
				</div>
				<div className="header-cell run-times-column" data-text-id="headerCell">
					{translation.runTimes}
				</div>
				<div className="header-cell distance-column" data-text-id="headerCell">
					{translation.totalDistance}
				</div>
				<div className="header-cell weight-column" data-text-id="headerCell">
					{translation.totalWeight}
				</div>
				<div className="header-cell handling-units-column" data-text-id="headerCell">
					{translation.handlingUnits}
				</div>
				<div className="driver-rank-column" data-text-id="headerCell">
					{translation.driverRank}
				</div>
			</div>
		);
	}
);

export default RouteHeader;
